"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isType = function (type) { return function (obj) {
    return obj != null &&
        (Array.isArray(type) ? type : [type]).some(function (t) { return exports.getType(obj) === "[object " + t + "]"; });
}; };
exports.getType = function (obj) { return Object.prototype.toString.call(obj); };
exports.isFn = isType([
    'Function',
    'AsyncFunction',
    'GeneratorFunction'
]);
exports.isArr = Array.isArray;
exports.isPlainObj = isType('Object');
exports.isStr = isType('String');
exports.isBool = isType('Boolean');
exports.isNum = isType('Number');
exports.isObj = function (val) { return typeof val === 'object'; };
exports.isRegExp = isType('RegExp');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/shared/lib/types.js
// module id = 148
// module chunks = 0